import React from 'react'
import styled from 'styled-components'
import CustomerOverrideForm from '../CustomerOverrideForm/CustomerOverrideForm'
import Toggle from '../Toggle'

const Wrapper = styled.div`
  display: flex;
  position: fixed;
  z-index: 1;
`

const AdminTools = ({ location }) => {
  return (
    <Wrapper>
      <CustomerOverrideForm location={location.pathname} />
      <Toggle />
    </Wrapper>
  )
}

export default AdminTools



// WEBPACK FOOTER //
// ./src/components/Header/AdminTools.js